import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://pclctuakdicrzqdemjid.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBjbGN0dWFrZGljcnpxZGVtamlkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA3ODI5ODUsImV4cCI6MjA2NjM1ODk4NX0.Ut7SuUKtzNzvWVb5d04TpxkZ9GlhlqtuuuhCMfXP6VU';

export const supabase = createClient(supabaseUrl, supabaseKey);
